// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__wZhzn","title":"AfterBackImages_title__2p5po","images":"AfterBackImages_images__2Vtdn"};